import { GraphQLReturn, useMutation } from '@cherre-frontend/data-fetching';
import { graphql } from 'react-relay';
import { useUnifiedIngestDuplicateTemplatesMutation } from './__generated__/useUnifiedIngestDuplicateTemplatesMutation.graphql';
import { $unifiedIngestReadTransformTemplates } from './useUnifiedIngestReadTemplates';

export const useUnifiedIngestDuplicateTemplates = () => {
  return useMutation(
    graphql`
      mutation useUnifiedIngestDuplicateTemplatesMutation(
        $params: unified_ingest_transform_templates_write_params!
      ) {
        unified_ingest_transform_templates_write(params: $params) {
          owner_name
          user_id
        }
      }
    ` as GraphQLReturn<useUnifiedIngestDuplicateTemplatesMutation>,
    {
      mapVariables:
        ({
          domOwner,
          templateUUID,
          userId,
          organizationSlug,
          targetTableName,
        }: {
          domOwner: string;
          templateUUID: string;
          userId: string;
          organizationSlug: string;
          targetTableName: string;
        }) =>
        async (ctx) => {
          const template = await ctx.getPromise(
            $unifiedIngestReadTransformTemplates({
              params: {
                owner_name: domOwner ?? '',
                template_uuid: templateUUID,
              },
            })
          );
          return {
            params: {
              owner_name: domOwner ?? '',
              user_id: userId?.toString() ?? '',
              org_slug: organizationSlug ?? '',
              template_id: template?.template_data.template_id
                ? `${template.template_data.template_id}${
                    userId ? '_' + userId : ''
                  }`
                : '',
              template_display_name:
                template?.template_data.template_display_name ?? '',
              is_production: true,
              source_system: template?.template_data.source_system ?? '',
              target_table: targetTableName,
              file_type: template?.template_data.file_type,
              example_file_id: template?.template_data.example_file_id,
              steps: template?.template_data.steps,
            },
          };
        },
    }
  );
};
